import React from "react";
import logo from "assets/img/henry-schein-logo-png-transparent.png";
import sidelogo from "assets/img/HS_Thrive Unlocked__Lockup.png";
import unlock from "assets/img/HS_Thrive Unlocked__K.O.png";
 
const PendingApproval = () => {
  return (
    <>
      <style>{mobileCss}</style>
 
      <div style={styles.page}>
        {/* HEADER */}
        <div style={styles.fullHeader}>
          <div className="header-content" style={styles.headerContent}>
            <img src={logo} style={styles.logo} alt="logo" />
 
            <img
              src={sidelogo}
              style={styles.rightLogo}
              alt="side-logo"
            />
          </div>
        </div>
 
        {/* CARD */}
        <div style={styles.card}>
          {/* CARD HEADER */}
          <div style={styles.cardHeader}>
            <img
              src={unlock}
              style={styles.unlockLogo}
              alt="unlock"
            />
          </div>
 
          <div style={styles.content}>
            {/* CLOCK ICON */}
            <div style={styles.clockWrap}>
              <svg viewBox="0 0 110 110" width="92" height="92">
                <circle
                  cx="52"
                  cy="52"
                  r="50"
                  fill="#fff"
                  stroke="#0A72BA"
                  strokeWidth="4"
                />
 
                <circle
                  cx="52"
                  cy="52"
                  r="34"
                  fill="none"
                  stroke="#0A72BA"
                  strokeWidth="3.5"
                  // opacity="0.35"
                />
 
                <line
                  x1="52"
                  y1="52"
                  x2="52"
                  y2="26"
                  stroke="#0A72BA"
                  strokeWidth="4"
                  strokeLinecap="round"
                />
 
                <line
                  x1="52"
                  y1="52"
                  x2="70"
                  y2="52"
                  stroke="#0A72BA"
                  strokeWidth="4"
                  strokeLinecap="round"
                />
 
                <circle
                  cx="52"
                  cy="52"
                  r="3"
                  fill="#0A72BA"
                />
              </svg>
 
              <div style={styles.hourglassBadge}>
                <svg viewBox="0 0 24 24" width="16" height="16">
                  <path
                    d="M6 3h12M6 21h12M7 3c0 4 5 6 5 9s-5 5-5 9M17 3c0 4-5 6-5 9s5 5 5 9"
                    stroke="#fff"
                    strokeWidth="1.8"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
            </div>
 
            {/* TITLE */}
            <h2 style={styles.title}>
              Pending Approval
            </h2>
 
            <p style={styles.subtitle}>
              Thank you! Your request is currently under review.
            </p>
 
            {/* INFO BOX */}
            <div className="info-box" style={styles.infoBox}>
              <div style={styles.infoTitle}>
                What happens next?
              </div>
 
              <p style={styles.infoText}>
                Our team is reviewing your request to confirm
                eligibility. You'll receive an email once your
                enrollment has been approved and your program
                benefits are available.
              </p>
            </div>
 
            {/* DIVIDER */}
            <div style={styles.divider}></div>
 
            {/* FOOTER */}
            <div style={styles.section}>
              <div style={styles.sectionTitle}>
                Have Questions?
              </div>
 
              <p style={styles.sectionText}>
                Contact Thrive Support, we're here to help.
              </p>
 
              <div
                className="contact-row"
                style={styles.contact}
              >
                <span style={styles.link}>
                  1-833-473-4968
                </span>
 
                <span style={{ margin: "0 8px" }}>
                  |
                </span>
 
                <a
                  href="mailto:Thrive.Support@henryschein.com"
                  style={{
                    color: "#2563eb",
                    textDecoration: "none",
                    wordBreak: "break-word",
                  }}
                >
                  Thrive.Support@henryschein.com
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
 
/* STYLES */
 
const styles = {
  page: {
    background: "#eef1f5",
    minHeight: "100vh",
    margin: 0,
    padding: "16px",
    fontFamily: "Arial, sans-serif",
    overflowX: "hidden",
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
 
  fullHeader: {
    width: "100%",
    maxWidth: "520px",
    background: "#fff",
    padding: "5px 16px",
    boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
    margin: "0 auto 20px auto",
    borderRadius: "10px",
    boxSizing: "border-box",
  },
 
  headerContent: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "15px",
  },
 
  logo: {
    width: "140px",
    height: "auto",
    objectFit: "contain",
  },
 
  rightLogo: {
    width: "220px",
    height: "auto",
    objectFit: "contain",
  },
 
  card: {
    width: "100%",
    maxWidth: "520px",
    background: "#fff",
    borderRadius: "14px",
    overflow: "hidden",
    boxShadow: "0 6px 18px rgba(0,0,0,.12)",
  },
 
  cardHeader: {
    background: "#0A72BA",
    textAlign: "center",
  },
 
  unlockLogo: {
    width: "100%",
    maxWidth: "260px",
    objectFit: "contain",
  },
 
  content: {
    padding: "28px",
  },
 
  clockWrap: {
    position: "relative",
    width: "92px",
    height: "92px",
    margin: "0 auto 18px",
  },
 
  hourglassBadge: {
    position: "absolute",
    bottom: 0,
    right: 0,
    width: "30px",
    height: "30px",
    borderRadius: "50%",
    background: "#F5A623",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    boxShadow: "0 0 0 3px #fff",
  },
 
  title: {
    textAlign: "center",
    color: "#0E176D",
    fontSize: "30px",
    fontWeight: "700",
    margin: "0 0 8px",
  },
 
  subtitle: {
    textAlign: "center",
    color: "#343F88",
    fontSize: "15px",
    lineHeight: "24px",
    marginBottom: "22px",
  },
 
  infoBox: {
    border: "1px solid #F5A623",
    background: "#FFF8F1",
    borderRadius: "10px",
    padding: "18px",
  },
 
  infoTitle: {
    color: "#F5A623",
    fontSize: "16px",
    fontWeight: "bold",
    marginBottom: "8px",
  },
 
  infoText: {
    color: "#343F88",
    fontSize: "14px",
    lineHeight: "24px",
    margin: 0,
  },
 
  divider: {
    height: "1px",
    background: "#E5E7EB",
    margin: "24px 0",
  },
 
  section: {},
 
  sectionTitle: {
    color: "#0E176D",
    fontWeight: "700",
    fontSize: "18px",
    marginBottom: "8px",
  },
 
  sectionText: {
    color: "#343F88",
    fontSize: "14px",
    lineHeight: "24px",
    marginBottom: "12px",
  },
 
  contact: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    fontSize: "14px",
    gap: "6px",
  },
 
  link: {
    color: "#2563EB",
    textDecoration: "none",
    cursor: "pointer",
    wordBreak: "break-word",
  },
};
 
const mobileCss = `
*{
  box-sizing:border-box;
}
 
body{
  margin:0;
  padding:0;
  overflow-x:hidden;
}
 
@media (max-width:768px){
 
  .header-content{
    display:flex !important;
    justify-content:space-between !important;
    align-items:center !important;
  }
 
  .contact-row{
    flex-direction:column !important;
    align-items:flex-start !important;
    gap:8px !important;
  }
 
}
 
@media (max-width:480px){
 
  .header-content img:first-child{
    width:100px !important;
  }
 
  .header-content img:last-child{
    width:150px !important;
  }
 
  h2{
    font-size:24px !important;
  }
 
}
`;
 
//  export default PendingApproval;
 
export default PendingApproval;